import { getCookie } from '../utilities/cookies'

export const SESSION_KEY = 'user_id'

export const getSessionKey = (prefix) =>
    `${prefix}${getCookie(SESSION_KEY) || ''}`
